import { render } from "./AboutView.vue?vue&type=template&id=1a34ed59"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\carlc\\portfolio\\portfolio-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__